var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isContentFragment, } from '../content-types';
import { getLoadableContentPaths } from './utils';
export function fetchContent(contentPath, contentApiConfig, logger, requestId) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            const response = yield fetch(`${contentApiConfig.origin}${contentApiConfig.path}?path=${encodeURIComponent(contentPath)}`, {
                headers: typeof ((_a = contentApiConfig.customConfig) === null || _a === void 0 ? void 0 : _a.apiKey) === 'string'
                    ? {
                        'X-API-KEY': contentApiConfig.customConfig.apiKey,
                    }
                    : {},
            });
            if (!response.ok) {
                throw new Error(`${response.status} - ${response.statusText}\n${yield response.text()}`);
            }
            const content = yield response.json();
            if (!isContentFragment(content.data)) {
                throw new Error(`Content is not a Content Fragment:\n${JSON.stringify(content, undefined, 2)}`);
            }
            return content.data;
        }
        catch (error) {
            if (logger) {
                logger.error(`Cannot load content for ${contentPath}${requestId ? ` (${requestId})` : ''}`, error);
            }
            throw error;
        }
    });
}
export function prefetchContentContainers(contentPaths, contentApiConfig, logger) {
    return __awaiter(this, void 0, void 0, function* () {
        const items = Array.isArray(contentPaths) ? contentPaths : [contentPaths];
        const uniqueContentPaths = getLoadableContentPaths(items, {});
        return Object.fromEntries(yield Promise.all(uniqueContentPaths.map((contentPath) => __awaiter(this, void 0, void 0, function* () {
            try {
                return [
                    contentPath,
                    (yield fetchContent(contentPath, contentApiConfig, logger, 'prefetch')),
                ];
            }
            catch (e) {
                return [contentPath, e];
            }
        }))));
    });
}
//# sourceMappingURL=fetch.js.map